import {roleConstants} from "./constants.js";

/** true if role is any of the roles in roles array
 * @param {string} role the current user's role, from "useUserRole()"
 * @param {string[]} roles array of roles from roleConstants
 * @returns {boolean}
 */
export function hasAnyRole(role, roles) {
    return roles.includes(role);
}

export function isAdmin(role) {
    return role === roleConstants.Admin
}

export function isTechnicalAdvanced(role) {
    return role === roleConstants.Technical
}

export function isTechnicalBasic(role) {
    return role === roleConstants.TechnicalBasic
}

export function isTechnicalOrMore(role) {
    return hasAnyRole(role, [roleConstants.Admin, roleConstants.Technical, roleConstants.TechnicalBasic])
}

export function isPremium(role) {
    return role === roleConstants.Premium
}

export function isBasic(role) {
    return role === roleConstants.Basic
}

export function isViewer(role) {
    return role === roleConstants.Viever
}

export function getRoleAsText(role) {
    return role || roleConstants.Viever
}

export const roleIdToText = (roleId) => {
    switch (roleId) {
        case process.env.REACT_APP_APP_ADMIN:
            return "App.Admin"
        case process.env.REACT_APP_APP_TECHNICALUSER: 
            return "App.Technical"
        case process.env.REACT_APP_APP_TECHNICALBASIC:
            return "App.TechnicalBasic"
        case process.env.REACT_APP_APP_PREMIUMUSER:
            return "App.Premium"
        case process.env.REACT_APP_APP_BASICUSER:
            return "App.BasicUser"
        case process.env.REACT_APP_APP_VIEWER:
            return "App.Viewer"
        default:
            throw new Error(`roleIdToText: No match for role id ${roleId}. possible roles are: [${process.env.REACT_APP_APP_ADMIN}, ${process.env.REACT_APP_APP_TECHNICALUSER}, ${process.env.REACT_APP_APP_TECHNICALBASIC}, ${process.env.REACT_APP_APP_PREMIUMUSER}, ${process.env.REACT_APP_APP_BASICUSER}, ${process.env.REACT_APP_APP_VIEWER}]`)
    }
}